<template>
	<div>
		<q-table
			ref="table"
			:data="data"
			:columns="columns"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
			class="q-mt-lg"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="trail_id" :props="props">
						{{ props.row.trail_id }}
					</q-td>
					
					<q-td key="trail_title" :props="props">
						{{ props.row.trail_title }}
					</q-td>

					<q-td key="percent" :props="props">
						{{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
					</q-td>

					<q-td key="result_date" :props="props">
						{{ getDateFormated(props.row.result_date) }}
					</q-td>

					<q-td key="status" :props="props" auto-width>
						<q-chip small :color="getColorStatus(props.row.status)">
							{{ $t(getStatus(props.row.status)) }}
						</q-chip>
					</q-td>

					<q-td key="trail_content_id" :props="props">
						<template v-if="props.row.trail_content_type !== 'news'">
							<q-btn
								flat
								round
								color="secondary"
								icon="far fa-file-edit"
								@click="showContents(props.row)"
							>
								<q-tooltip>
									{{ $t('contents') }}
								</q-tooltip>
							</q-btn>
						</template>
					</q-td>

					<q-td key="certificate_id" :props="props">
						<q-btn v-if="props.row.status === 1" flat round color="secondary" icon="far fa-eye" @click="showCertificate(props.row.trail_id)" >
                            <q-tooltip>
                                {{ $t('view_certificate_tooltip')}}
                            </q-tooltip>
                        </q-btn>
					</q-td>
				</q-tr>
			</template>
		</q-table>
		<content-modal v-if="show_trail_contents" :show_trail_contents="show_trail_contents" @hide_report="hideReport()" :trail_title="trail_title" :trail_id="trail_id"/>
		<certificate :show="show_certificate" :data="certificate_data" @hideCertificate="hideCertificate" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import ContentModal from './ContentModal.vue'
import Certificate from 'components/Certificate'
const { formatDate } = date

export default {
	name: 'Results',

	components: {
		'content-modal': ContentModal,
        'certificate': Certificate
	},

	data() {
		return {
			loading: false,
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			columns: [
				{
                    name: 'trail_id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'trail_id',
                    sortable: false,
                },
				{
					name: 'trail_title',
					required: true,
					label: 'title',
					align: 'left',
					field: 'trail_title',
					sortable: false,
				},
				{
					name: 'percent',
					required: true,
					label: 'user_performance',
					align: 'left',
					field: 'percent',
					sortable: false,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: false,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: false,
				},
				{
					name: 'trail_content_id',
					required: true,
					label: 'contents',
					align: 'left',
					field: 'trail_content_id',
					sortable: false,
				},
				{
                    name: 'certificate_id',
                    required: true,
                    label: 'certificate',
                    align: 'left',
                    field: 'certificate_id',
                    sortable: false,
                },
			],
			data: [],
			show_trail_contents: false,
			certificate_data: [],
			show_certificate: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			selected_user: 'users/selected_user',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getHeaderUrlencoded() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
			}

			this.savePagination()

			this.$axios
				.get(`/admin_users/users/${this.selected_user}/get_user_trail_user_results/?${this.$qs.stringify(data)}`,this.getHeader)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.data = []

					response.data.results.forEach( ( result ) => {
						this.data.push(result)
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		getDateFormated(d) {
			return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
		},

		getStatus(status) {
			if (status == 1) return 'aproved'
			else if (status == 2) return 'reproved'
			else if (status == 3) return 'restarted'
			else return 'pending'
		},

		getColorStatus(status) {
			if (status == 1) return 'positive'
			else if (status == 2) return 'negative'
			else if (status == 3) return 'warning'
			else return ''
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		showContents({ trail_id, trail_title }) {
			this.trail_title = trail_title
			this.trail_id = trail_id
			this.show_trail_contents = true
		},

		hideReport() {
			this.show_trail_contents = false
			this.loadPagination()
		},

		showCertificate(id){
            this.$q.loading.show()

			let data = {
                'user_id': this.selected_user
            }

			this.$axios.post(`/etraining_trails/trails/${id}/get_trail_user_result_certificate/`, this.$qs.stringify(data), this.getHeaderUrlencoded)
			.then(response => {
				this.certificate_data = response.data.image
                this.show_certificate = true
			})
			.catch(e => {
				console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            });
        },

		hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },
	},

	watch: {
		num_rows: {
			handler(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	created() {
		this.loadPagination()
		this.request({ pagination: this.server_pagination })
	},
}
</script>

<style>
</style>
